import { notification } from 'antd';

export const styleNotification = {
    borderRadius: 4
};

notification.config({
    top: 45,
    duration: 10,
    maxCount: 1
});

export const showNotification = (config, cleanOrder) => {
    try {
        notification.open(config);
        setTimeout(() => {
            cleanOrder();
        }, 1000);
    } catch (error) {
        console.error('Error showing notification', error);
    } 
    
};